import {ConnectionUser} from '@lib/store';
import {
  SECTION_ID_CONNECTION_WITHOUT_WORKDAY,
  SECTION_ID_CONNECTION_WITH_WORKDAY,
  constructConnectionFilterWithWorkday,
  constructConnectionFilterWithoutWorkday,
} from '../filterConstructors';
import {TFunction} from 'i18next';

export const constructCalendarOverviewConnectionFilter = (
  connectionsWithWorkday: ConnectionUser[],
  connectionsWithoutWorkday: ConnectionUser[],
  t: TFunction,
) => {
  const withWorkday = constructConnectionFilterWithWorkday(connectionsWithWorkday, t);
  const withoutWorkday = constructConnectionFilterWithoutWorkday(connectionsWithoutWorkday, t);

  return {
    [SECTION_ID_CONNECTION_WITH_WORKDAY]: withWorkday,
    [SECTION_ID_CONNECTION_WITHOUT_WORKDAY]: withoutWorkday,
  };
};
